import gen from '../gen'
import auth from '../auth/auth'
import userDetails from './userDetails'
import firebase from 'firebase/app'
import 'firebase/auth';
import configurations from '../../../configurations'

const state = {
  uploadProfilePhotoWidget: null 
}

const getters = {

}

const mutations = {
  //
  uploadNCrop_profilePic(state2) {
    this.uploadProfilePhotoWidget = cloudinary.createUploadWidget({
      cloudName: configurations.cloudinary_cloudName,
      uploadPreset: "1920px",
      imageMetadata: true,
      theme: 'minimal',
      multiple: false,
      showPoweredBy: false,
      sources: ['local']
    },
      (error, result) => {
        //save img link to db
        if (result.event === "success") {
          let picDetail = result.info
          let thumbnailUrl = picDetail.thumbnail_url
          let picUrl = picDetail.url
          //
          var user = firebase.auth().currentUser;
          //
          user.updateProfile({
            photoURL: thumbnailUrl
          }).then(function () {
            // console.log("[session][photoURL] // Update successful.")
            //
            userDetails.state.userDetails_photoURL = thumbnailUrl //thumbnail
            //
            gen
              .actions
              .mergeDocToDb(state, {
                dbPath: 'users/' + auth.state.user.uid,
                obj: {
                  picUrl
                }
              }).then(()=>{
              //
              gen.mutations.snackbar_alert(state, {
                msg: 'Image Uploaded !'
              })
              //
              userDetails.state.userDetails_userDetails_profilePicUrl = picUrl
              //
              window.thisOfVueComp.$forceUpdate()
              //
            })
            //
          }).catch(function(error) {
            console.log("[session][photoURL] // An error happened.")
          });
        }
        if (error) {
          console.log(error)
        }
      });
  },
  openCloudinaryWidget(){
    this.uploadProfilePhotoWidget.open();
  }
  //
}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user/uploadProfilePhoto.js